import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Component({
    selector:
    '.m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-body',
    templateUrl: './default.component.html',
    encapsulation: ViewEncapsulation.None
})
export class DefaultComponent implements OnInit {
    title$: Observable<string>;
    title: string;

    constructor() { }
    ngOnInit() {
        // (<any>$("body")).mCustomScrollbar(
        //     {theme:"dark-2",
        //     mouseWheel:{scrollAmount:500}
        // });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/default.component.ts